import { useEffect, useState } from 'preact/hooks';
import { supabase, AMBIENTE } from './supabase';
import { etapaActual, type Etapa } from './acceso/acceso';
import { Entrar } from './acceso/Entrar';
import { Inscribir } from './acceso/Inscribir';
import { Codigo } from './acceso/Codigo';
import { Sistema } from './Sistema';

export function App() {
  const [etapa, setEtapa] = useState<Etapa>(supabase ? 'cargando' : 'sin-configurar');
  const [correo, setCorreo] = useState('');
  const revisar = () => {
    if (!supabase) return;
    const sb = supabase;
    etapaActual(sb).then(setEtapa).catch(() => setEtapa('sin-conexion'));
    sb.auth.getSession().then(({ data }) => setCorreo(data.session?.user.email || ''));
  };
  useEffect(() => {
    if (!supabase) return;
    revisar();
    // No se llama a Supabase dentro del aviso (puede trabarse): se revisa en el siguiente ciclo.
    const { data } = supabase.auth.onAuthStateChange(() => { setTimeout(revisar, 0); });
    return () => data.subscription.unsubscribe();
  }, []);
  const sb = supabase;
  return (
    <main class={'wrap' + (etapa === 'adentro' ? ' ancho' : '')}>
      <header class="top">
        <div>
          <h1>Talentino<span class="punto">.</span> <small>Sistema</small></h1>
          {AMBIENTE === 'pruebas' && <p class="ambiente">Ambiente de pruebas · datos ficticios</p>}
        </div>
        {sb && correo && etapa !== 'entrar' && (
          <div class="sesion"><span class="hint">{correo}</span><button class="btn" type="button" onClick={() => sb.auth.signOut()}>Salir</button></div>
        )}
      </header>
      {!sb || etapa === 'sin-configurar' ? <section class="panel"><p class="estado error">Falta configurar la conexión con la base de datos.</p></section>
        : etapa === 'cargando' ? <section class="panel"><p class="hint">Cargando…</p></section>
        : etapa === 'sin-conexion' ? <section class="panel"><p class="estado error">No hay conexión con el sistema. Revisa el internet y recarga la página.</p></section>
        : etapa === 'entrar' ? <Entrar sb={sb} onListo={revisar} />
        : etapa === 'inscribir' ? <Inscribir sb={sb} onListo={revisar} />
        : etapa === 'codigo' ? <Codigo sb={sb} onListo={revisar} />
        : <Sistema sb={sb} />}
    </main>
  );
}
